import type { ReactNode } from 'react'
import { cx } from '../utils/cx'
import './KeypadHint.css'

export interface KeypadHintItem {
  /** Texto bajo la viñeta, p. ej. "1 · Toca el teclado para encenderlo" */
  label: ReactNode
  /** Teclas resaltadas (1–9, en orden de lectura) */
  keys?: number[]
  /** Resalta la barra inferior (encender / confirmar) */
  bar?: boolean
  /** Color del resaltado: primary (acción) o success (confirmación) */
  tone?: 'primary' | 'success'
}

export interface KeypadHintProps {
  items: KeypadHintItem[]
  className?: string
}

/** Viñeta de teclado (bundle B4): mini-ilustración CSS de 64 × 88 (rejilla 3 × 3 + barra), tres pasos en fila. Funciona sin conexión y con texto grande. */
export function KeypadHint({ items, className }: KeypadHintProps) {
  return (
    <ol className={cx('hp-keypad', className)}>
      {items.map((it, i) => (
        <li key={i} className="hp-keypad__step">
          <div className={cx('hp-keypad__pad', `hp-keypad__pad--${it.tone ?? 'primary'}`)} aria-hidden="true">
            {Array.from({ length: 9 }, (_, k) => (
              <span key={k} className={cx('hp-keypad__key', it.keys?.includes(k + 1) && 'hp-keypad__key--on')} />
            ))}
            <span className={cx('hp-keypad__key hp-keypad__key--bar', it.bar && 'hp-keypad__key--on')} />
          </div>
          <div className="hp-keypad__label tnum">{it.label}</div>
        </li>
      ))}
    </ol>
  )
}
